export const getNextDate = date => new Date(date.getTime() + 24 * 60 * 60 * 1000);

export default null;
